import * as React from "react";
import { TravelersContent } from "./TravelersContent";
import { TravelersDialogProps } from "../typings";
import { observer } from "mobx-react";

export const TravelersDialog: React.FunctionComponent<TravelersDialogProps> = observer((props) => {
  return (
    <TravelersContent
      key={`${props.queryRouteId}-dialog-picker`}
      travelers={props.travelers}
      onSave={props.onSave}
      onChange={props.onChange}
      config={props.config}
      invalid={props.invalid}
      lobState={props.lobState}
    />
  );
});
